/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import ToastActions from 'actions/ToastActions';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import AuthActions from 'auth/AuthActions';
import BoxFooter from 'components/BoxFooter.jsx';
import UserActions from 'user/UserActions';

class JoinInfoPageCreateFullAccount extends React.Component {
  props: {
    onDone: Function,
    onError: Function,
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  state: {
    canSubmit: boolean,
  }

  state = {
    canSubmit: false,
  }

  onPreexistingAccount = () => {
    AuthActions.signOut('/log_in');
  }

  onSubmit = (attrs: {email: string, password: string}, _: any, invalidateForm: Function) => {
    const onSuccess = (user) => {
      AuthActions
        .signIn(attrs.email, attrs.password)
        .then(() => {
          this.props.onDone(user);
        })
        .catch(e => console.error('JoinInfoPageCreateFullAccount onSubmit failed', e));
    };

    const onFailure = (error) => {
      if (!error || error.code !== 'validation_error') {
        ToastActions.showDefaultErrorToast();
        return;
      }

      this.props.onError(error);

      const errors = {};
      for (const field of error.field_errors) {
        errors[field['field_name']] = field.messages.join(', ');
      }

      invalidateForm(errors);
    };

    UserActions.update({ email: attrs.email, password: attrs.password }).then(onSuccess, onFailure);
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  }

  enableButton = () => {
    this.setState({ canSubmit: true });
  }

  render() {
    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageCreateFullAccount"
        title={'Enter account details'}>
        <BoxBody divided>
          <Form
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.onSubmit} >
            <FormInput
              label="Email address"
              type="email"
              name="email"
              // even though this is an email, let the browser know to use this as username in the future
              autoComplete="username"
              placeholder="Email address"
              validations="isEmail"
              showErrorAfterBlur
              className="JoinInfoPageCreateFullAccount-Email"
              validationError="Invalid email address. Please try again."
            />
            <FormInput
              label="Choose a password"
              name="password"
              placeholder="Password"
              type="password"
              autoComplete="new-password"
              validOnPristine
              validations="minLength:6"
              className="JoinInfoPageCreateFullAccount-Password"
              validationError="Passwords should be at least 6 characters long."
            />
            <Button
              className="JoinInfoPageCreateFullAccount-Submit"
              disabled={!this.state.canSubmit}
              type="submit"
              eventElementName="JoinInfoPageCreateFullAccount-Submit">
              Done
            </Button>
          </Form>
        </BoxBody>
        <BoxFooter className="JoinInfoPageCreateFullAccount-footer">
          Already have an account?
          {' '}
          <Link onClick={this.onPreexistingAccount}>Log in</Link>.
        </BoxFooter>
      </DialogContent>
    );
  }
}

export default JoinInfoPageCreateFullAccount;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoPageCreateFullAccount.jsx